import { render, staticRenderFns } from "./SvList.vue?vue&type=template&id=bc793ce4&"
import script from "./SvList.vue?vue&type=script&lang=js&"
export * from "./SvList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports